/**
 * Passes the proper config object to the application at run/build time.
 */
import config from "./__ENV__";

const contact = 'support@gopreem.com';

export default {... config, contact};